import React from 'react'
import { IntlProvider } from 'react-intl'
import { distinctUntilChanged, map } from 'rxjs/operators'
import { AppStore, useAppState } from 'state/store'
import { FrontendLocale } from './I18N.state'
import ar from './translations/ar.json'
import da from './translations/da.json'
import de from './translations/de.json'
import en from './translations/en.json'
import es from './translations/es.json'
import fi from './translations/fi.json'
import fr from './translations/fr.json'
import it from './translations/it.json'

const translations: any = {
  de,
  en,
  da,
  fi,
  it,
  fr,
  es,
  ar,
}

export const AppIntlProvider: React.FC<{
  children?: React.ReactNode
}> = props => {
  const locale = useAppState(state => state.i18n.locale)
  const language = locale.split(/[-_]/)[0] // language without region code
  const messages: any = translations[language] || translations['de']
  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      {...({ children: props.children } as any)}
    />
  )
}

const LangReg = /lang=(\w*)&?/

export function connectTranslationSwitch(store: AppStore) {
  store.state$
    .pipe(
      map(update => update.state.location.search),
      distinctUntilChanged()
    )
    .subscribe(search => {
      const matches = LangReg.exec(search)
      if (matches) {
        const language = matches[1] as FrontendLocale
        if (language) {
          store.next(s => {
            s.i18n.locale = language
          })
        }
      }
    })
}
